var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconsAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "application-add-streamline-sharp-1__Application-Add--Streamline-Sharp 1",
    className: "application-add-streamline-sharp-1__Application-Add--Streamline-Sharp application-add-streamline-sharp-1__1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "application-add-streamline-sharp-1__Vector (Stroke)",
    fill: "currentColor",
    d: "M16.782 14.37c.288-.925 1.621-.93 1.917-.008l.026.096.03.13a3.057 3.057 0 0 0 2.456 2.33c1.097.192 1.097 1.766 0 1.958a3.056 3.056 0 0 0-2.456 2.33l-.03.13c-.24 1.05-1.738 1.044-1.968-.008l-.025-.112a3.037 3.037 0 0 0-2.446-2.342c-1.095-.19-1.095-1.763 0-1.953l.225-.048a3.037 3.037 0 0 0 2.221-2.295l.025-.112.025-.095Zm.961 1.151a4.286 4.286 0 0 1-2.36 2.376 4.286 4.286 0 0 1 2.36 2.375 4.306 4.306 0 0 1 2.373-2.375 4.306 4.306 0 0 1-2.373-2.376Z",
    className: "application-add-streamline-sharp-1__Vector application-add-streamline-sharp-1__(Stroke)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "application-add-streamline-sharp-1__Vector 3805 (Stroke)",
    fill: "currentColor",
    d: "M8.546 15.434V6.536a.75.75 0 1 1 1.5 0v8.898a.75.75 0 0 1-1.5 0Z",
    className: "application-add-streamline-sharp-1__Vector application-add-streamline-sharp-1__3805 application-add-streamline-sharp-1__(Stroke)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "application-add-streamline-sharp-1__Vector 3811 (Stroke)",
    fill: "currentColor",
    d: "M17.941 10.308V4.413a.25.25 0 0 0-.25-.25H3.707a.25.25 0 0 0-.25.25v13.21c0 .139.112.25.25.25h7.718a.75.75 0 0 1 0 1.5H3.707a1.75 1.75 0 0 1-1.75-1.75V4.413c0-.967.784-1.75 1.75-1.75h13.984c.967 0 1.75.783 1.75 1.75v5.895a.75.75 0 0 1-1.5 0Z",
    className: "application-add-streamline-sharp-1__Vector application-add-streamline-sharp-1__3811 application-add-streamline-sharp-1__(Stroke)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "application-add-streamline-sharp-1__Vector 3806 (Stroke)",
    fill: "currentColor",
    d: "M11.76 15.433v-4.5a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0Z",
    className: "application-add-streamline-sharp-1__Vector application-add-streamline-sharp-1__3806 application-add-streamline-sharp-1__(Stroke)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "application-add-streamline-sharp-1__Vector 3809 (Stroke)",
    fill: "currentColor",
    d: "M14.988 9.187v-2.65a.75.75 0 0 1 1.5 0v2.65a.75.75 0 0 1-1.5 0Z",
    className: "application-add-streamline-sharp-1__Vector application-add-streamline-sharp-1__3809 application-add-streamline-sharp-1__(Stroke)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "application-add-streamline-sharp-1__Vector 3810 (Stroke)",
    fill: "currentColor",
    d: "M14.988 12.479V12a.75.75 0 0 1 1.5 0v.479a.75.75 0 0 1-1.5 0Z",
    className: "application-add-streamline-sharp-1__Vector application-add-streamline-sharp-1__3810 application-add-streamline-sharp-1__(Stroke)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "application-add-streamline-sharp-1__Vector 3808 (Stroke)",
    fill: "currentColor",
    d: "M5.308 15.434V8.382a.75.75 0 1 1 1.5 0v7.052a.75.75 0 0 1-1.5 0Z",
    className: "application-add-streamline-sharp-1__Vector application-add-streamline-sharp-1__3808 application-add-streamline-sharp-1__(Stroke)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconsAi);
export default __webpack_public_path__ + "static/media/sidebar-icons-ai.fd6e4edd62d3cc066d7f393b45a481ed.svg";
export { ForwardRef as ReactComponent };